module.exports = {
  title: 'Fibonacci Sphere with React Native Skia 🌐',
  author: 'Enzo Manuel Mangano',
  date: '2024-01-10',
  slug: 'fibonacci-shader',
  tags: ['skia', 'reanimated'],
};
